import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom"; // ← Added
import "./brandShowcase.css";

const BrandShowcase = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate(); // ← Added

  const sectionRef = useRef(null);
  const textWrapperRef = useRef(null);
  const textRefs = useRef([]);

  const brands = [
    {
      id: 1,
      name: "Mokosh",
      description:
        "Mokosh Cosmetics produces exceptional natural cosmetics that captivate with their quality and selection of raw materials, texture and fragrance.",
      buttonText: "CHECK PRODUCTS",
      imageUrl:
        "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/mokosh-bg.jpg?v=1704193943&width=3000",
    },
    {
      id: 2,
      name: "BKIND",
      description:
        "At BKIND, we offer all-natural, plant-based, vegan, eco-friendly beauty and skin care products made in Quebec.",
      buttonText: "CHECK PRODUCTS",
      imageUrl:
        "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/bkind4.jpg?v=1661081139&width=3000",
      hasDivider: true,
    },
    {
      id: 3,
      name: "Herbivore",
      description:
        "Herbivore believes in the power of nature to bring tangible results you can see and feel.",
      buttonText: "CHECK PRODUCTS",
      imageUrl:
        "https://wonder-theme-beauty.myshopify.com/cdn/shop/files/herbi-bg-4.jpg?v=1756904366&width=3000",
    },
  ];

  // Handler for "CHECK PRODUCTS" button
  const handleCheckProducts = (brandName) => {
    navigate(`/products?brand=${encodeURIComponent(brandName)}`);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveIndex(Number(entry.target.dataset.index));
          }
        });
      },
      { root: textWrapperRef.current, threshold: 0.6 }
    );

    textRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const section = sectionRef.current;
    const textWrapper = textWrapperRef.current;

    const onWheel = (e) => {
      const rect = section.getBoundingClientRect();
      const fullyInView = rect.top <= 0 && rect.bottom >= window.innerHeight;

      if (!fullyInView) return;

      const atTop = textWrapper.scrollTop <= 0;
      const atBottom =
        textWrapper.scrollTop + textWrapper.clientHeight >=
        textWrapper.scrollHeight - 1;

      if ((e.deltaY > 0 && !atBottom) || (e.deltaY < 0 && !atTop)) {
        e.preventDefault();
        document.body.style.overflow = "hidden";
        textWrapper.scrollTop += e.deltaY;
      } else {
        document.body.style.overflow = "auto";
      }
    };

    window.addEventListener("wheel", onWheel, { passive: false });

    return () => {
      window.removeEventListener("wheel", onWheel);
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <section className="brand-showcase-section" ref={sectionRef}>
      <div className="brand-showcase-container">
        <div className="brand-image-wrapper">
          <div className="brand-sticky-image">
            {brands.map((brand, index) => (
              <div
                key={brand.id}
                className={`brand-image-container ${
                  activeIndex === index ? "active" : ""
                }`}
              >
                <img
                  src={brand.imageUrl}
                  alt={brand.name}
                  className="brand-image"
                />
              </div>
            ))}
          </div>
        </div>

        <div className="brand-text-wrapper" ref={textWrapperRef}>
          {brands.map((brand, index) => (
            <div
              key={brand.id}
              ref={(el) => (textRefs.current[index] = el)}
              data-index={index}
              className={`brand-text-item ${
                activeIndex === index ? "active" : ""
              }`}
            >
              <div className="brand-text-content">
                <h2 className="brand-name">{brand.name}</h2>
                {brand.hasDivider && <div className="brand-divider" />}
                <p className="brand-description">{brand.description}</p>
                <button
                  className="brand-button"
                  onClick={() => handleCheckProducts(brand.name)} // ← Added
                >
                  {brand.buttonText}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrandShowcase;